import React, { useEffect } from "react";
import "./Modal.css";

const Modal = ({
  children,
  onClose,
  size = "md",
  closeOnOverlay = true,
  showCloseButton = true,
  className = "",
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = originalOverflow;
    };
  }, [onClose]);

  const handleOverlayClick = () => {
    if (closeOnOverlay) {
      onClose?.();
    }
  };

  const modalSizeClass =
    size === "sm"
      ? "ab-modal-shell-sm"
      : size === "lg"
      ? "ab-modal-shell-lg"
      : size === "xl"
      ? "ab-modal-shell-xl"
      : "ab-modal-shell-md";

  return (
    <div className="ab-modal-overlay" onClick={handleOverlayClick}>
      <div
        className={`ab-modal-shell ${modalSizeClass} ${className}`.trim()}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {showCloseButton && (
          <button className="ab-modal-close" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        )}

        <div className="ab-modal-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;